import React from 'react';
import { compose, mapProps, withPropsOnChange, lifecycle } from 'recompose';
import propEq from 'ramda/src/propEq';
import pathOr from 'ramda/src/pathOr';
import prop from 'ramda/src/prop';
import omit from 'ramda/src/omit';
import sortWith from 'ramda/src/sortWith';
import ascend from 'ramda/src/ascend';
import descend from 'ramda/src/descend';
import Destination from './Destination';
import FilterBar from './FilterBar';
import Loading from './Loading';
import { nonOptimalStates } from './hocs/helpers';
import { Flex, Div, OvercastIcon } from './hocs/withStyles';
import * as analytics from '../utils/analyticsUtils';

const NoDestinations = ({ originName, departureDate, returnDate }) => (
  <Div m={[2, 1]}>
    <Div m={[1]}>
      <OvercastIcon />
    </Div>
    <Div m={[1]}>
      We did not find any great destinations. Try changing the filters or the dates?
    </Div>
  </Div>
);

const Destinations = compose(
  lifecycle({
    componentDidMount() {
      this.props.fetchDestisWithFares(this.props.route.params[0]);
    }
  }),
  nonOptimalStates([
    {
      when: propEq('destinations', null),
      render: props => <Loading {...props} forDestinations />
    }
  ]),
  withPropsOnChange(
    ['destinations', 'departureDate', 'returnDate', 'oneWay', 'originCountryId'],
    ({
      uid,
      destinations,
      origin,
      originCountry,
      originCountryId,
      currency,
      departureDate,
      returnDate,
      dailyWeather,
      dates,
      language,
      oneWay
    }) => {
      return {
        destinations: destinations.map(d => ({
          ...d,
          goToSkyscanner: () => {
            const skyBaseUrl =
              'http://partners.api.skyscanner.net/apiservices/referral/v1.0';
            const skyShortKey = 'ka78298653624725';
            const destination = d.iataCode;
            const url = `${skyBaseUrl}/${originCountryId}/${currency}/${language}/${
              origin
            }/${destination}/${departureDate}/${oneWay ? '/' : returnDate}?${
              skyShortKey
            }`;
            analytics.countSkyscannerClick({
              uid,
              url,
              origin,
              destination,
              departureDate,
              returnDate,
              quote: d.quote.price || 0,
              currency
            });
            window.open(url);
          }
        }))
      };
    }
  ),
  withPropsOnChange(['destinations', 'filters'], ({ destinations, filters }) => {
    return {
      destinations: destinations.filter(d => {
        if (!filters.nonStop && !d.quote.isDirect) return false;
        const isSunnyEnough = d.numSunDays >= filters.minSunDays;
        if (isSunnyEnough) return true;
        return false;
      })
    };
  }),
  withPropsOnChange(['destinations', 'order'], ({ destinations, order }) => {
    return {
      destinations: sortWith(
        order === 'distance'
          ? [ascend(prop('distance'))]
          : order === 'price'
            ? [ascend(pathOr(0, ['quote', 'price']))]
            : order === 'warm'
              ? [descend(prop('avgTemp'))]
              : [
                  descend(prop('numClearDays')),
                  descend(prop('numSunDays')),
                  ascend(pathOr(0, ['quote', 'price']))
                ],
        destinations
      )
    };
  }),
  mapProps(omit(['fetchDestinations', 'fetchDestisWithFares']))
)(props => {
  const {
    destinations,
    origin,
    originName,
    departureDate,
    returnDate,
    degreeUnit,
    oneWay
  } = props;
  return (
    <Flex direction="column" width="100%">
      <Div>
        <FilterBar {...props} />
      </Div>
      <Div>
        {!destinations.length ? (
          <NoDestinations {...props} />
        ) : (
          destinations.map(d => {
            if (!d || !d.iataCode) return null;
            return (
              <Flex
                key={d.iataCode}
                m={[1, 0, 2, 0]}
                minHeight="10vh"
                bg="white"
                shadow={true}
              >
                <Destination
                  {...d}
                  degreeUnit={degreeUnit}
                  origin={origin}
                  originName={originName}
                  departureDate={departureDate}
                  returnDate={returnDate}
                  oneWay={oneWay}
                />
              </Flex>
            );
          })
        )}
      </Div>
    </Flex>
  );
});
export default Destinations;



// WEBPACK FOOTER //
// ./src/components/Destinations.js